<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Block Group
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryFilterForm"
                            v-model="filters.blkGrp"
                            :label="filtersLabel.blkGrp"
                            :error-messages="errors.collect('filterBlkGrp')"
                            data-vv-name="filterBlkGrp"
                            :data-vv-as="filtersLabel.blkGrp"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="dataHeaders"
          :items="blkGrpItems"
          v-bind:options.sync="pagination"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItems"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.blkGrp }}</td>
              <td>{{ row.item.blkGrpDescS }}</td>
              <td style="text-align:center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assign(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      actionName: '',
      filtersLabel: {
        blkGrp: 'Block Group'
      },
      filters: {
        blkGrp: undefined
      },
      blkGrpItems: [],
      totalItems: 0,
      dataHeaders: [
        { text: 'Block Group', align: 'left', value: 'blkGrp' },
        { text: 'Block Group Description Short', value: 'blkGrpDescS' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    }
  },
  mounted() {
    if (this.$store.state.blkParam.init !== 1) {
      this.$store.dispatch('blkParamManagementInit')
    }
    this.doClearFilters()
    this.fetchData()
  },
  methods: {
    closeDialog() {
      this.filters.blkGrp = ''
      this.$emit('close')
    },
    doClearFilters() {
      this.filters.blkGrp = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryFilterForm').then(result => {
        if (result) {
          this.pagination.page = 1
          this.fetchData()
        }
      })
    },
    assign(data) {
      // Use $emit to call parent page method assign and pass the value
      this.$emit('assign-blkGrp-info', data)
      this.$emit('assign-blkGrp', data.blkGrp)
      this.$emit('close')
    },
    async fetchData() {
      const apiUrl = this.menu.getBlkGrpList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = {
            accmType: this.accmType,
            blkGrp: this.filters.blkGrp
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result && result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this, 'blkGrpItems', data)
            } else {
              this.$set(this, 'blkGrpItems', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  watch: {
    'pagination': function(value) {
      this.fetchData()
    }
  },
  props: {
    accmType: {
      type: String,
      default: undefined
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
